// extracted by mini-css-extract-plugin
module.exports = {"unsubButton":"Footer_unsubButton__9ELMx"};